import React from "react"
import LinkButton from "@components/common/LinkButton"
import SoftDropdownButton from "../../common/SoftDropDownButton"

const MainMenu = ({
	openMegaMenu,
	handleMenu,
	openCollabMenu,
	handleCollabMenu,
}) => {
	return (
		<React.Fragment>
			<section className="relative gap-x-6 text-black text-sm ml-8">
				{/* DESKTOP */}
				<section className="hidden lg:flex justify-between flex-row items-start lg:items-center max-w-[1440px] mx-auto flex-1 gap-x-6 xl:gap-x-8 gap-y-8">
					<SoftDropdownButton
						label={"SHOP"}
						onClick={handleMenu}
						disableDefaultDropdown={true}
						openOnHover={true}
						className={"flex-1 justify-between"}
						isOpenRef={openMegaMenu}
					/>
					<LinkButton
						className={"font-bold text-red-600"}
						label={"SALE"}
						to={"/collections/sale/"}
						ariaLabel="SALE"
					/>
					<LinkButton
						label={"NEW"}
						to={"/collections/new-arrivals/"}
						ariaLabel="NEW"
					/>
					<LinkButton
						label={"BEST SELLERS"}
						to="/collections/bestsellers"
						ariaLabel="BEST SELLERS"
					/>
					<SoftDropdownButton
						label={"COLLABS"}
						onClick={handleCollabMenu}
						disableDefaultDropdown={true}
						openOnHover={true}
						className={"flex-1 justify-between"}
						isOpenRef={openCollabMenu}
					/>
					<LinkButton
						label={"LOOKBOOK"}
						to="/lookbooks/"
						ariaLabel="LOOKBOOK"
					/>
					<LinkButton
						label={"BLUE PACT"}
						className={"font-extrabold text-[#41629E]"}
						to="/blue-pact"
						ariaLabel="blue pact"
					/>
				</section>
			</section>
		</React.Fragment>
	)
}

export default MainMenu
